import { Checkbox } from '@sgcmpteltd/uikit-react';
import cx from 'clsx';
import { useEffect, useRef, useState } from 'react';

import {
  ListTypeLabel,
} from '@/app/(routes)/listing/_components/page-content/search-list/car-card/listing-type-label'; // @suppress longLineCheck

import styles from './styles.module.scss';
import type { Component } from './types';

export const SubmodelToggleCheckbox: Component = ({
  submodelId,
  submodelName,
  isOnCompared,
  submodelIndex,
  isSelected,
  isFacelift,
  isNewVariant,
  onSelectSubmodel,
  onComparedCheckboxChange,
}) => {
  const nameRef = useRef<HTMLDivElement>(null);
  const [isMultiLine, setIsMultiLine] = useState(false);

  useEffect(() => {
    if (nameRef.current) {
      const { width } = nameRef.current.getBoundingClientRect();

      setIsMultiLine(width > 200);
    }
  }, [submodelName]);

  return (
    <div className={cx(
      styles.containerToggleCheckbox,
      isSelected && styles.isSelected,
    )}>
      <div className={styles.containerCheckbox}>
        <Checkbox
          checked={isOnCompared}
          id={`${submodelId}`}
          size={16}
          value={submodelId}
          onChange={
            () => onComparedCheckboxChange(submodelId, submodelIndex)
          } />
      </div>
      <button
        className={cx(
          styles.btnSubmodelName,
          isMultiLine && styles.isMultiLine,
        )}
        onClick={() => onSelectSubmodel(submodelId, submodelIndex)}>
        <div className={styles.containerSubmodelName}>
          <div className={cx(
            styles.iconArrowRight,
            isSelected && styles.isSelected,
          )} />
          <div
            ref={nameRef}
            className={styles.textSubmodelName}>
            {submodelName}
          </div>
        </div>
        {isFacelift && (
          <ListTypeLabel
            labelSize={10}
            type="facelift" />
        )}
        {
          isNewVariant && (
            <ListTypeLabel
              labelSize={10}
              type="newSubmodel" />
          )
        }
      </button>
    </div>
  );
};
